import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import FluidBackgroundImg from 'Components/Utility/FluidBackgroundImg';

const GiftThemeHeader = ({ theme }) => {
  let themeSrc = 'gift-christmas-bg.jpg';
  if (theme === 'birthday') themeSrc = 'birthday-bg.jpg';
  if (theme === 'thanksgiving') themeSrc = 'thanksgiving-bg.jpg';
  if (theme === 'chinesenewyear') themeSrc = 'China-bg-2.jpg';
  return (
    <FluidBackgroundImg
      src={themeSrc}
      folder="assets"
      subfolder="gifting"
      className="gift-theme-header"
    >
      <div className="header-area">
        <div className="header-title">
          {theme === 'christmas' &&
            <FormattedMessage id="giftthemeheader.merrychristmas" defaultMessage="Merry Christmas" />
          }

          {theme === 'birthday' &&
            <FormattedMessage id="giftthemeheader.birthday" defaultMessage="Level Up!" />
          }

          {theme === 'thanksgiving' &&
            <FormattedMessage id="giftthemeheader.happy" defaultMessage="Happy" />
          }

        </div>
        <div className="subheader-area">
          {theme === 'birthday' &&
            <FormattedMessage id="giftthemeheader.happybirthday" defaultMessage="Happy Birthday" />
          }
          {theme === 'thanksgiving' &&
            <FormattedMessage id="giftthemeheader.thanksgiving" defaultMessage="Thanksgiving" />
          }
        </div>
      </div>
    </FluidBackgroundImg>
  );
};

GiftThemeHeader.propTypes = {
  theme: PropTypes.bool,
};

GiftThemeHeader.defaultProps = {
  theme: 'standard',
};


export default GiftThemeHeader;
